import React from 'react'



class Whatis extends React.Component {


  render() {

    return (  
      <section className="pt-100 mb-0">
          <div className="container">
            <h2 className="heading-h2 text-center"><span className='bluecolor'>Who</span> We Are</h2>
            <div className="text-center">
              <p className="pharagraph text-center">Coinsclone is an established and trusted blockchain development company and a subsidiary of Pixel Web Solutions, combining years of software engineering craftsmanship with modern blockchain technologies. Since 2018, we have been helping startups and enterprises to launch their brand with our digital solutions that impact the emerging crypto industry.</p>
              <p className="pharagraph text-center">With a team of 50+ blockchain experts, we have completed over 600+ projects in over 80 countries. We specialize in developing secure, scalable, and customizable white-label platforms, including cryptocurrency exchanges, NFT marketplaces, and DeFi platforms.</p>
              <p className="pharagraph text-center mb-0">At Coinsclone, we provide more than just development. We will work with you to understand your vision, identify the real problem, and develop custom solutions that are tenant-specific, user-friendly, compliant, and scalable. With our experience in the blockchain space, we're here to help you innovate, grow, and take the lead in Web3.</p>
            </div>
          </div>
      </section>
    )
  }
}

export default Whatis